module.exports = __webpack_public_path__ + "static/smarthome-1-3x-c11db6806ae3e814132875c07ef33e54.png";